import { authRoles } from 'app/main/consts';
import Register from './Register';

const RegisterConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: authRoles.guest,
	routes: [
		{
			path: '/register',
			component: Register
		}
	]
};

export default RegisterConfig;
